var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.canCancel)?_c('button',{attrs:{"disabled":_vm.isLoading},on:{"click":_vm.cancelReport}},[_c('i',{staticClass:"icon icon-close"}),_vm._v(" "+_vm._s(_vm.isLoading ? _vm.$tc("cancelReport.canceling") : _vm.$tc("cancelReport.label"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }